module.exports = __webpack_public_path__ + "media/images/lb/693-9f967179e0c7b2298f1b7993059b9b94.svg";